/**
 * @generated SignedSource<<181e25eafd383515fa678c4d4e247121>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum ConfluenceContentAccessRequestStatus {
  APPROVE = "APPROVE",
  DENY = "DENY",
  PENDING = "PENDING",
  PENDING_SITE_APPROVAL = "PENDING_SITE_APPROVAL",
}
export enum ConfluenceRequestAccessApprovalDecision {
  APPROVE = "APPROVE",
  DENY = "DENY",
}
export interface ConfluenceUpdateContentAccessRequestInput {
  accessRequestedAccountId: Scalars["ID"]["input"];
  accessType: ResourceAccessType;
  approvalDecision: ConfluenceRequestAccessApprovalDecision;
  contentId: Scalars["ID"]["input"];
  requestId: Scalars["ID"]["input"];
}
export enum ResourceAccessType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_AdminAnnouncementBannerMutationErrorExtension =
  {
    __typename?: "AdminAnnouncementBannerMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_ConfluenceUpdateContentAccessRequestMutationErrorExtension =
  {
    __typename?: "ConfluenceUpdateContentAccessRequestMutationErrorExtension";
    displayName: string;
    processedRequestStatus: ConfluenceContentAccessRequestStatus;
    errorType: string | null;
    statusCode: number | null;
  };
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_ConfluenceUpdatePdfExportConfigurationMutationErrorExtension =
  {
    __typename?: "ConfluenceUpdatePdfExportConfigurationMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_ConfluenceUpdateSiteConfigurationMutationErrorExtension =
  {
    __typename?: "ConfluenceUpdateSiteConfigurationMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_GenericMutationErrorExtension =
  {
    __typename?: "GenericMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_ReopenCommentsMutationErrorExtension =
  {
    __typename?: "ReopenCommentsMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_ResolveCommentsMutationErrorExtension =
  {
    __typename?: "ResolveCommentsMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_ResolveRestrictionsForSubjectMutationErrorExtension =
  {
    __typename?: "ResolveRestrictionsForSubjectMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_UpdateExCoSpacePermissionsMutationErrorExtension =
  {
    __typename?: "UpdateExCoSpacePermissionsMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_UpdateSpacePermissionsMutationErrorExtension =
  {
    __typename?: "UpdateSpacePermissionsMutationErrorExtension";
    errorType: string | null;
    statusCode: number | null;
  };
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions =

    | AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_AdminAnnouncementBannerMutationErrorExtension
    | AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_ConfluenceUpdateContentAccessRequestMutationErrorExtension
    | AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_ConfluenceUpdatePdfExportConfigurationMutationErrorExtension
    | AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_ConfluenceUpdateSiteConfigurationMutationErrorExtension
    | AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_GenericMutationErrorExtension
    | AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_ReopenCommentsMutationErrorExtension
    | AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_ResolveCommentsMutationErrorExtension
    | AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_ResolveRestrictionsForSubjectMutationErrorExtension
    | AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_UpdateExCoSpacePermissionsMutationErrorExtension
    | AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions_UpdateSpacePermissionsMutationErrorExtension;
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError =
  {
    __typename?: "MutationError";
    message: string | null;
    extensions: Array<AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError_extensions | null> | null;
  };
export type AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload =
  {
    __typename?: "ConfluenceUpdateContentAccessRequestPayload";
    success: boolean;
    errors: Array<AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload_errors_MutationError>;
  };
export type AccessRequestsTableRowMutation_Mutation = {
  __typename?: "Mutation";
  confluence_updateContentAccessRequest: AccessRequestsTableRowMutation_confluence_updateContentAccessRequest_ConfluenceUpdateContentAccessRequestPayload | null;
};
export type AccessRequestsTableRowMutationVariables = Exact<{
  cloudId: Scalars["ID"]["input"];
  updateContentAccessRequestInput: ConfluenceUpdateContentAccessRequestInput;
}>;
export type AccessRequestsTableRowMutation =
  AccessRequestsTableRowMutation_Mutation;
